export const transaksiMasukFormData = (
  dropdownPelanggan,
  noTransMasuk,
  dropdownOnlyKas
) => {
  const tanggalSaatIni = new Date().toISOString().slice(0, 10);

  return [
    {
      id: "nomor_transaksi_masuk",
      label: "Nomor Transaksi Masuk",
      fields: [
        {
          type: "readonly",
          defaultValue: noTransMasuk,
        },
      ],
    },
    {
      id: "tanggal_transaksi_masuk",
      label: "Tanggal Transaksi Masuk",
      fields: [
        {
          type: "date",
          defaultDate: true,
          defaultDateValue: tanggalSaatIni,
        },
      ],
    },
    {
      id: "id_pelanggan",
      label: "Penyetor",
      fields: [
        {
          type: "option",
          options: dropdownPelanggan,
        },
      ],
    },
    {
      id: "jumlah_transaksi_masuk",
      label: "Jumlah Transaksi Masuk",
      fields: [
        {
          type: "input",
          placeholder: "Masukan Nilai Transaksi...",
        },
      ],
    },
    {
      id: "via_bayar_transaksi_masuk",
      label: "Via Bayar",
      fields: [
        {
          type: "option",
          options: dropdownOnlyKas,
        },
      ],
    },
    {
      id: "keterangan_transaksi_masuk",
      label: "Keterangan Transaksi Masuk",
      fields: [
        {
          type: "input",
          placeholder: "Masukan Keterangan Transaksi Masuk...",
        },
      ],
    },
    {
      id: "bukti_transaksi_masuk",
      label: "Upload Bukti Transaksi ( .jpg / .png / .jpeg) (optional)",
      fields: [
        {
          type: "file_multiple",
        },
      ],
    },
  ];
};

export const transaksiMasukPindahAnggaranFormData = (
  dropdownAnggaranPemasukan
) => {
  return [
    {
      id: "id_anggaran_pemasukan",
      label: "Pilih Anggaran Pemasukan",
      fields: [
        {
          type: "option",
          options: dropdownAnggaranPemasukan,
        },
      ],
    },
  ];
};
